/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
import React from 'react';

import Fade from 'react-reveal/Fade';

import Button from 'elements/Button';

export default function Portfolio({ data }) {
  return (
    <section className="container mx-auto flex flex-col items-center mt-24 mb-20">
      <Fade bottom>
        <h1 className="text-5xl lg:text-6xl text-theme-blue text-center font-bold mb-4">Case Studies</h1>

        <p className="font-light text-lg lg:text-xl text-gray-600 text-center mb-16 max-w-3xl mx-auto">
          Explore how we have helped businesses and industries with our intelligent
          software solutions.
        </p>
      </Fade>

      <div className="grid grid-cols-2 sm:grid-cols-3 sm:gap-4 xl:gap-6 justify-items-center">
        {
                    data.map((item, index) => (
                      <Fade bottom delay={500 * index}>
                        <Button type="link" href={`/project/${item.id}`}>
                          <div className="group rounded-2xl shadow-lg w-auto w-11/12 m-3 transform transition-all duration-500 hover:scale-105 hover:shadow-2xl portofolio-card overflow-hidden bg-white">
                            <div className="relative overflow-hidden">
                              <img src={item.imageUrl} alt="Portfolio" className="rounded-t-2xl z-0 transform transition-transform duration-500 group-hover:scale-110" />
                              <div className="absolute flex w-full h-full top-0 opacity-0 bg-gradient-to-t from-theme-purple/90 to-dark-theme-purple/80 justify-center items-center rounded-t-2xl rounded-b img-hover transition-opacity duration-300 group-hover:opacity-100">
                                <button className="focus:outline-none transform transition-transform duration-300 group-hover:scale-110" aria-label="View portfolio item">
                                  <svg className="w-20 h-20 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                  </svg>
                                </button>
                              </div>
                            </div>
                            <div className="py-5 px-3">
                              <h2 className="text-theme-blue text-center text-lg font-semibold group-hover:text-theme-purple transition-colors duration-300">{item.title}</h2>
                              <p className="font-light text-gray-500 text-center text-sm mt-1">{item.type}</p>
                            </div>
                          </div>
                        </Button>
                      </Fade>
                    ))
                }
      </div>

      <Fade bottom>
        <Button href="/case-studies" type="link" className="group flex flex-grow-0 w-auto h-12 sm:h-14 px-8 text-theme-purple border-2 border-theme-purple items-center mt-16 rounded-lg justify-center transition-all duration-300 hover:bg-gradient-to-r hover:from-theme-purple hover:to-dark-theme-purple hover:text-white hover:shadow-lg hover:scale-105">
          <p className="font-semibold text-base lg:text-lg">
            View All Case Studies
          </p>
          <svg className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform duration-300" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </Button>
      </Fade>
    </section>
  );
}
